// // export default EmiDueReport;
// import React, { useMemo, useState } from "react";
// import { Link } from "react-router-dom";
// import '../css/CenterReport.css'
// import { Edit, Trash } from "lucide-react";

// const CenterReport = () => {
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // 🔍 Search + Pagination
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);

// // Static data
//   const staticData = [
//     {
//       branchId: "56",
//       superAdminId: "14",
//       location: "Mumbai",
//       createdDate: "20-4-2025",
//       createdTime: "10:40 pm",
//     },
    
//   ];

// // search and filter logic
//   const filteredStaticData = useMemo(() => {
//     let data = [...staticData];

//     if (searchQuery.trim()) {
//       data = data.filter((item) =>
//         Object.values(item)
//           .join(" ")
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase())
//       );
//     }

//     return data;
//   }, [searchQuery]);

// // pagination
//   const totalPagesFD = Math.ceil(filteredStaticData.length / rowsPerPage);

//   const paginatedDataFD = filteredStaticData.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   return (
//     <div className="center-report-container">
//       <h1 className="center-report-title">Center Report</h1>

//       {/* Rows per page */}
//       <div className="center-report-filters">
//         <input
//           type="text"
//           placeholder="Search by any field..."
//           value={searchQuery}
//           onChange={(e) => {
//             setSearchQuery(e.target.value);
//             setCurrentPage(1);
//           }}
//         />

//         <label>
//           Show{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => {
//               setRowsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//             <option value={100}>100</option>
//           </select>{" "}
//           entries
//         </label>
//       </div>

//       {/* Search input */}
//       {/* <div className="DDFDReportsearch-box">
//         <input
//           type="text"
//           placeholder="Search by any field..."
//           value={searchQuery}
//           onChange={(e) => {
//             setSearchQuery(e.target.value);
//             setCurrentPage(1);
//           }}
//         />
//       </div> */}

//       {/* Table */}
//       <div className="center-report-section">
//         <table className="center-report-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Branch Id</th>
//               <th>Super Admin Id</th>
//               <th>Location</th>
//               <th>Created Date</th>
//               <th>Created Time</th>
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {paginatedDataFD.length === 0 ? (
//               <tr>
//                 <td colSpan="10" className="center-report-no-records">
//                   ✅ No records found
//                 </td>
//               </tr>
//             ) : (
//               paginatedDataFD.map((sdata, i) => (
//                 <tr key={i}>
//                   <td>{(currentPage - 1) * rowsPerPage + i + 1}</td>
//                   <td>{sdata.branchId}</td>
//                   <td>{sdata.superAdminId}</td>
//                   <td>{sdata.location}</td>
//                   <td>{sdata.createdDate}</td>
//                   <td>{sdata.createdTime}</td>
//                   <td className="center-report-btns">
//                     <button
//                       className="center-report-edit-btn"
//                       // onClick={() => {
//                       //   setIsModalOpen(true);
//                       //   setSelectedCustomer(row);
//                       // }}
//                       title="Edit" // tooltip on hover
//                     >
//                       <Edit />
//                     </button>

//                     <button
//                       className="center-report-delete-btn"
//                       // onClick={() => openDeleteDialog(row.id)}
//                       title="Delete"
//                     >
//                       <Trash />
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="center-report-pagination-btns">
//         <button
//           onClick={() => setCurrentPage((p) => p - 1)}
//           disabled={currentPage === 1}
//         >
//           ⬅ Previous
//         </button>

//         <span>
//           Page {currentPage} of {totalPagesFD || 1}
//         </span>

//         <button
//           onClick={() => setCurrentPage((p) => p + 1)}
//           disabled={currentPage === totalPagesFD || totalPagesFD === 0}
//         >
//           Next ➡
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CenterReport;



// ----------------------------------------------------------

import React, { useEffect, useMemo, useState } from "react";
import "../css/CenterReport.css";
import { Edit, Trash } from "lucide-react";
import axios from "axios";

const CenterReport = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const ITEMS_PER_PAGE_OPTIONS = [5, 10, 20];

  const [modalOpen, setModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [loading, setLoading] = useState(false);

  const [centers, setCenters] = useState([]);
  const [selectedCenterId, setSelectedCenterId] = useState(null);

  const [formData, setFormData] = useState({
    groupName: "",
    city: "",
    collectionTime: "",
    collectionDay:"",
    address:"",
  });

  /* ================= INPUT HANDLER ================= */
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  /* ================= RESET FORM ================= */
  const resetForm = () => {
    setFormData({
      centerName: "",
      city: "",
      collectionTime: "",
      collectionDay:"",
      address:"",
    });
    setEditIndex(null);
  };

  /* ================= GET CENTERS ================= */
  const fetchCenters = async () => {

    const superAdminId=localStorage.getItem("adminuserId")
    // console.log("Super Admin Id",superAdminId)
    setLoading(true);
    try {
      const res = await axios.get(`https://payyug.in/api/group/centre?superAdminId=${superAdminId}`);
      console.log("center list",res.data.data)
      setCenters(res.data?.data || []);
      if (res.data?.data?.length > 0) {
        setSelectedCenterId(res.data.data[0].id);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCenters();
  }, []);

  /* ================= UPDATE (ADMIN ONLY) ================= */
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (editIndex === null) return;

    if (!formData.centerName || !formData.city || !formData.collectionTime || !formData.collectionDay || !formData.address) {
      alert("Please fill required fields");
      return;
    }

    try {
      const id = centers[editIndex]?.id;

      const payload = {
        CenterName: formData.centerName,
        city: formData.city,
        MeetingTime: formData.collectionTime,
        RecoveryDay:formData.collectionDay,
        address:formData.address
      };

      const res = await axios.put(
        `https://payyug.in/api/group/centre/${id}`,
        payload
      );

      alert(res.data?.message || "Updated successfully");
      fetchCenters();
      setModalOpen(false);
    } catch (err) {
      alert(err.response?.data?.message || "Update failed");
    }
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!id) return alert("Invalid ID");

    if (!window.confirm("Are you sure you want to delete this group?")) return;

    try {
      const res = await axios.delete(
        `https://payyug.in/api/group/centre/${id}`
      );
      alert(res.data?.message || "Group deleted successfully");
      fetchCenters();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to delete group");
    }
  };

  /* ================= SEARCH + PAGINATION ================= */
  const filteredData = useMemo(() => {
    return centers.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  }, [centers, searchQuery]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <div className="center-container">
        <h1 className="center-heading">Center Report</h1>

        <div className="center-report-filter-section">
          <div className="center-report-filter-div">
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            <div className="center-filter">
              <label>Show </label>
              <select
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                value={itemsPerPage}
              >
                {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
              <span> entries</span>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="center-report-table-container">
          <table className="center-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Center Name</th>
                <th>Center Code</th>
                <th>Center Leader Id</th>
                <th>City/Village</th>
                <th>Collection Time</th>
                <th>Recovery Day</th>
                <th>Address</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{item.CenterName}</td>
                    <td>{item.CenterCode}</td>
                    <td>{item.center_leader_id}</td>
                    <td>{item.city}</td>
                    <td>{item.MeetingTime}</td>
                    <td>{item.RecoveryDay}</td>
                    <td>{item.address}</td>

                    <td className="center-action-btns">
                      <Edit
                        className="edit-icon"
                        onClick={() => {
                          const globalIndex =
                            (currentPage - 1) * itemsPerPage + index;
                          setEditIndex(globalIndex);

                          setFormData({
                            centerName: item.CenterName,
                            city: item.city,
                            collectionTime: item.MeetingTime,
                            collectionDay:item.RecoveryDay,
                            address:item.address,
                          });

                          setSelectedCenterId(item.CenterId);
                          setModalOpen(true);
                        }}
                      />
                      <Trash
                        className="delete-icon"
                        onClick={() => handleDelete(item.id)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center" }}>
                    {loading ? "Loading..." : "No results found"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {filteredData.length > itemsPerPage && (
          <div className="center-pagination-div">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              ⬅ Prev
            </button>

            <span>
              Page {currentPage} of {totalPages}
            </span>

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next ➡
            </button>
          </div>
        )}

        {/* Modal */}
        {modalOpen && (
          <div className="center-dialog-overlay">
            <div className="center-dialog-box">
              <h2 className="center-dialog-box-heading">Edit Center Report</h2>

              <form
                className="center-dialog-box-form-section"
                onSubmit={handleUpdate}
              >
                <div className="center-dialog-box-form-grid">
                  <div className="center-dialog-box-input-group">
                    <label>Center Name</label>
                    <input
                      type="text"
                      name="centerName"
                      value={formData.centerName}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="center-dialog-box-input-group">
                    <label>City/Village</label>
                    <input
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="center-dialog-box-input-group">
                    <label>Collection Time</label>
                    <input
                      type="time"
                      name="collectionTime"
                      value={formData.collectionTime}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="center-dialog-box-input-group">
                    <label>Collection Day</label>
                    <select name="collectionDay" id="" value={formData.collectionDay} onChange={handleChange}>
                      <option value=""></option>
                      <option value="Sunday">Sunday</option>
                      <option value="Monday">Monday</option>
                      <option value="Tuesday">Tuesday</option>
                      <option value="Wednesday">Wednesday</option>
                      <option value="Thursday">Thursday</option>
                      <option value="Friday">Friday</option>
                      <option value="Saturday">Saturday</option>
                    </select>
                  </div>

                  <div className="center-dialog-box-input-group">
                    <label>Address</label>
                    <textarea
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="center-dialog-btns">
                  <button type="submit">Update</button>
                  <button type="button" onClick={() => setModalOpen(false)}>
                    Cancel
                  </button>
                  <button type="button" onClick={resetForm}>
                    Reset
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CenterReport;
